import { Button } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import AddLeadBoosterPromoLeadsModal from 'components/providers/AddLeadBoosterPromoLeadsModal'

interface AddLeadBoosterPromoLeadsButtonProps {
    providerId: number
}

export default function AddLeadBoosterPromoLeadsButton({
    providerId,
}: AddLeadBoosterPromoLeadsButtonProps) {
    return (
        <Button
            onClick={() => NiceModal.show(AddLeadBoosterPromoLeadsModal, { providerId })}
            name="text">
            Add Promo
        </Button>
    )
}
